export const ROUTE_PATH = '/signup';
